(function () {
  'use strict';

  // Prezzi fallback in centesimi (usati solo se CFG.prices non è impostato)
  var PREZZI_CLASSICO = [5990, 7990, 11990, 15990, 19990, 23990, 27990, 31990, 35990];
  var PREZZI_3D       = [6990, 9490, 13990, 18490, 22990, 27490, 31990, 36490, 40990];

  var CFG = window.MIYO_CONFIG || {};
  var PERSONE_MAX = 6;
  var ANIMALI_MAX = 3;
  var TOTAL_STEPS = 6;

  var state = {
    currentStep: 1,
    fotoMiyo: null,
    persone: 1,
    animali: 0,
    stile: null,
    testo: false,
    testoValore: '',
    cornice: false,
  };

  /* ---- DOM refs ---- */
  var overlay       = document.getElementById('miyo-popup-overlay');
  var triggerBtn    = document.getElementById('miyo-trigger-btn');
  var closeBtn      = overlay.querySelector('.miyo-close');
  var backBtn       = document.getElementById('miyo-back');
  var nextBtn       = document.getElementById('miyo-next');
  var cartBtn       = document.getElementById('miyo-add-cart');
  var progressBar   = document.getElementById('miyo-progress-bar');
  var progressLabel = document.getElementById('miyo-progress-label');
  var livePriceEl   = document.getElementById('miyo-live-price');
  var errorEl       = document.getElementById('miyo-error');

  var personeMinus  = document.getElementById('persone-minus');
  var personePlus   = document.getElementById('persone-plus');
  var personeCount  = document.getElementById('persone-count');
  var animaliMinus  = document.getElementById('animali-minus');
  var animaliPlus   = document.getElementById('animali-plus');
  var animaliCount  = document.getElementById('animali-count');

  var testoToggle   = document.getElementById('testo-toggle');
  var testoArea     = document.getElementById('testo-area');
  var testoInput    = document.getElementById('testo-input');
  var charCount     = document.getElementById('char-count');

  var corniceToggle = document.getElementById('cornice-toggle');

  var fotoSlot     = document.getElementById('miyo-foto-slot');
  var fotoStatusEl = document.getElementById('miyo-foto-status');

  var summaryRows  = document.getElementById('miyo-summary-rows');
  var totalPriceEl = document.getElementById('miyo-total-price');

  var pricePanelEl = document.getElementById('miyo-price-panel');
  var priceRowsEl  = document.getElementById('miyo-price-rows');
  var priceTotalEl = document.getElementById('miyo-price-total-val');

  /* ---- Inject trigger button next to native ATC ---- */
  triggerBtn.removeAttribute('hidden');
  triggerBtn.style.display = 'block';
  var nativeAtc = document.querySelector('form[action*="/cart/add"] [type="submit"], .product-form__submit, [name="add"]');
  if (nativeAtc) {
    nativeAtc.parentNode.insertBefore(triggerBtn, nativeAtc);
    nativeAtc.style.display = 'none';
  }

  /* ---- Pricing ---- */
  function getPriceCents() {
    var stile = state.stile || 'Classico';
    var total = Math.min(state.persone + state.animali, 9);
    var idx = total - 1;
    var p = CFG.prices;
    if (p) {
      if (state.animali > 0) {
        var animArr = p[stile + 'Animali'] || [];
        if (animArr[idx] > 0) return animArr[idx];
      }
      var arr = p[stile] || [];
      if (arr[idx] > 0) return arr[idx];
    }
    var prezzi = stile === '3D' ? PREZZI_3D : PREZZI_CLASSICO;
    return prezzi[Math.max(0, idx)] || (CFG.basePrice || 0);
  }

  function calcTotalCents() {
    var base = getPriceCents();
    if (state.testo) base += 250;
    if (state.cornice) base += 250;
    return base;
  }

  function getMainVariantId() {
    var stile = state.stile || 'Classico';
    var total = Math.min(state.persone + state.animali, 9);
    var idx = total - 1;
    var v = CFG.variants;
    if (!v) return CFG.mainVariantId;
    if (state.animali > 0) {
      var animArr = v[stile + 'Animali'] || [];
      if (animArr[idx] > 0) return animArr[idx];
    }
    var arr = v[stile] || [];
    return arr[idx] || CFG.mainVariantId;
  }

  function formatPrice(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function renderPricePanel() {
    if (!priceRowsEl || !priceTotalEl) return;

    var stileLabel = state.stile || 'Classico';
    var baseCents = getPriceCents();

    var personLabel = state.persone + (state.persone === 1 ? ' persona' : ' persone');
    var animalSuffix = state.animali > 0
      ? ' + ' + state.animali + (state.animali === 1 ? ' animale' : ' animali')
      : '';

    var html = '<div class="miyo-price-row">' +
      '<span>Miyo ' + stileLabel + ' &middot; ' + personLabel + animalSuffix + '</span>' +
      '<span class="miyo-price-row-val">' + formatPrice(baseCents) + '</span>' +
      '</div>';

    if (state.testo) {
      html += '<div class="miyo-price-row miyo-price-row--addon">' +
        '<span>Testo inciso</span>' +
        '<span class="miyo-price-addon-val">+€2,50</span>' +
        '</div>';
    }
    if (state.cornice) {
      html += '<div class="miyo-price-row miyo-price-row--addon">' +
        '<span>Cornice con foto</span>' +
        '<span class="miyo-price-addon-val">+€2,50</span>' +
        '</div>';
    }

    priceRowsEl.innerHTML = html;
    priceTotalEl.textContent = formatPrice(calcTotalCents());
  }

  function updateLivePrice() {
    if (livePriceEl) livePriceEl.textContent = formatPrice(calcTotalCents());
    renderPricePanel();
  }

  /* ---- Upload via uploadcare.openDialog() ---- */
  function createUploadArea(slot, statusEl, onSuccess) {
    var btn = document.createElement('div');
    btn.className = 'miyo-upload-area';
    btn.setAttribute('role', 'button');
    btn.setAttribute('tabindex', '0');
    btn.innerHTML =
      '<div class="miyo-upload-icon">&#128247;</div>' +
      '<div class="miyo-upload-text"><strong>Scegli una foto</strong></div>' +
      '<div class="miyo-upload-hint">JPG, PNG</div>';

    var previewWrap = null;

    function openDialog() {
      if (!window.uploadcare) {
        statusEl.textContent = 'Ricarica la pagina e riprova.';
        statusEl.className = 'miyo-error';
        statusEl.removeAttribute('hidden');
        return;
      }
      var dialog = uploadcare.openDialog(null, { imagesOnly: true });
      dialog.done(function (file) {
        statusEl.textContent = 'Caricamento…';
        statusEl.className = 'miyo-uploading';
        statusEl.removeAttribute('hidden');
        file.promise().done(function (info) {
          onSuccess(info.cdnUrl);
          statusEl.textContent = 'Foto caricata correttamente';
          statusEl.className = 'miyo-upload-ok';

          if (previewWrap) previewWrap.remove();
          previewWrap = document.createElement('div');
          previewWrap.className = 'miyo-preview-wrap';
          var img = document.createElement('img');
          img.src = info.cdnUrl;
          img.alt = 'Foto caricata';
          var removeBtn = document.createElement('button');
          removeBtn.type = 'button';
          removeBtn.className = 'miyo-remove-photo';
          removeBtn.setAttribute('aria-label', 'Rimuovi foto');
          removeBtn.textContent = '×';
          removeBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            onSuccess(null);
            previewWrap.remove();
            previewWrap = null;
            statusEl.setAttribute('hidden', '');
            btn.style.display = 'block';
          });
          previewWrap.appendChild(img);
          previewWrap.appendChild(removeBtn);
          slot.insertBefore(previewWrap, btn);
          btn.style.display = 'none';
        }).fail(function () {
          statusEl.textContent = 'Errore nel caricamento. Riprova.';
          statusEl.className = 'miyo-error';
        });
      });
    }

    btn.addEventListener('click', openDialog);
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openDialog(); }
    });

    slot.appendChild(btn);
  }

  createUploadArea(fotoSlot, fotoStatusEl, function (url) { state.fotoMiyo = url; });

  /* ---- Open / Close ---- */
  triggerBtn.addEventListener('click', openPopup);
  closeBtn.addEventListener('click', closePopup);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) closePopup(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay.classList.contains('is-visible')) closePopup(); });

  function openPopup() {
    overlay.classList.add('is-visible');
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { overlay.classList.remove('is-visible'); }, 260);
  }

  /* ---- Navigation ---- */
  backBtn.addEventListener('click', function () { goToStep(state.currentStep - 1); });
  nextBtn.addEventListener('click', function () {
    if (!validate(state.currentStep)) return;
    goToStep(state.currentStep + 1);
  });
  cartBtn.addEventListener('click', addToCart);

  function goToStep(n) {
    document.querySelector('[data-miyo-step="' + state.currentStep + '"]').hidden = true;
    document.querySelector('[data-miyo-step="' + n + '"]').hidden = false;
    state.currentStep = n;
    updateUI();
    if (n === TOTAL_STEPS) renderSummary();
    clearError();
  }

  function updateUI() {
    var s = state.currentStep;
    backBtn.hidden = s === 1;
    nextBtn.hidden = s === TOTAL_STEPS;
    cartBtn.hidden = s !== TOTAL_STEPS;
    if (pricePanelEl) pricePanelEl.hidden = s === 1 || s === TOTAL_STEPS;
    if (livePriceEl) livePriceEl.hidden = true;
    progressBar.style.width = ((s / TOTAL_STEPS) * 100) + '%';
    progressLabel.textContent = 'Passo ' + s + ' di ' + TOTAL_STEPS;
    updateLivePrice();
  }

  /* ---- Validation ---- */
  // 1=Foto, 2=Persone, 3=Stile, 4=Testo, 5=Cornice, 6=Riepilogo
  function validate(step) {
    clearError();
    if (step === 1 && !state.fotoMiyo) {
      setError('Carica la tua foto per creare il Miyo.');
      return false;
    }
    if (step === 3 && !state.stile) {
      setError('Seleziona uno stile per continuare.');
      return false;
    }
    if (step === 4 && state.testo && !state.testoValore.trim()) {
      setError("Inserisci il testo oppure disattiva l'opzione.");
      return false;
    }
    return true;
  }

  function setError(msg) {
    errorEl.textContent = msg;
    errorEl.removeAttribute('hidden');
    errorEl.style.display = 'block';
  }
  function clearError() {
    errorEl.setAttribute('hidden', '');
    errorEl.style.display = '';
  }

  /* ---- Step 2: Stepper ---- */
  personePlus.addEventListener('click', function () { if (state.persone < PERSONE_MAX) { state.persone++; refreshSteppers(); } });
  personeMinus.addEventListener('click', function () { if (state.persone > 1) { state.persone--; refreshSteppers(); } });
  animaliPlus.addEventListener('click', function () { if (state.animali < ANIMALI_MAX) { state.animali++; refreshSteppers(); } });
  animaliMinus.addEventListener('click', function () { if (state.animali > 0) { state.animali--; refreshSteppers(); } });

  function refreshSteppers() {
    personeCount.textContent = state.persone;
    animaliCount.textContent = state.animali;
    personeMinus.disabled = state.persone <= 1;
    personePlus.disabled  = state.persone >= PERSONE_MAX;
    animaliMinus.disabled = state.animali <= 0;
    animaliPlus.disabled  = state.animali >= ANIMALI_MAX;
    updateLivePrice();
  }

  /* ---- Step 3: Stile cards ---- */
  document.querySelectorAll('.miyo-card').forEach(function (card) {
    card.addEventListener('click', function () {
      document.querySelectorAll('.miyo-card').forEach(function (c) { c.classList.remove('is-selected'); });
      card.classList.add('is-selected');
      state.stile = card.dataset.stile;
      updateLivePrice();
    });
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); card.click(); }
    });
  });

  /* ---- Step 4: Testo ---- */
  testoToggle.addEventListener('change', function () {
    state.testo = testoToggle.checked;
    testoArea.hidden = !state.testo;
    if (!state.testo) { state.testoValore = ''; testoInput.value = ''; charCount.textContent = '0'; }
    updateLivePrice();
  });
  testoInput.addEventListener('input', function () {
    state.testoValore = testoInput.value;
    charCount.textContent = testoInput.value.length;
  });

  /* ---- Step 5: Cornice toggle ---- */
  corniceToggle.addEventListener('change', function () {
    state.cornice = corniceToggle.checked;
    updateLivePrice();
  });

  /* ---- Step 6: Summary ---- */
  function renderSummary() {
    var animaliLabel = state.animali === 0 ? 'Nessuno' : state.animali + (state.animali === 1 ? ' animale' : ' animali');
    var rows = [
      ['Persone', state.persone + (state.persone === 1 ? ' persona' : ' persone')],
      ['Animali', animaliLabel],
      ['Stile', state.stile],
      ['Testo personalizzato', state.testo ? ('"' + state.testoValore + '"') : 'No'],
      ['Cornice con foto', state.cornice ? 'S\xec (+€2,50)' : 'No'],
    ];
    summaryRows.innerHTML = rows.map(function (r) {
      return '<div class="miyo-summary-row"><span class="miyo-row-label">' + r[0] + '</span><span class="miyo-row-value">' + r[1] + '</span></div>';
    }).join('');
    totalPriceEl.textContent = formatPrice(calcTotalCents());
  }

  /* ---- Add to cart ---- */
  async function addToCart() {
    cartBtn.disabled = true;
    cartBtn.textContent = 'Aggiungendo…';
    clearError();

    var props = {
      'Persone': state.persone,
      'Animali': state.animali > 0 ? state.animali : 'Nessuno',
      'Stile': state.stile,
      '_Foto': state.fotoMiyo,
    };
    if (state.testo) props['Testo inciso'] = state.testoValore;
    if (state.cornice) props['_Foto cornice'] = state.fotoMiyo;

    var testoId   = parseInt(CFG.testoVariantId, 10);
    var corniceId = parseInt(CFG.corniceVariantId, 10);
    var items = [{ id: getMainVariantId(), quantity: 1, properties: props }];
    if (state.testo && testoId > 0) items.push({ id: testoId, quantity: 1 });
    if (state.cornice && corniceId > 0) items.push({ id: corniceId, quantity: 1 });

    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items }),
      });
      if (!res.ok) {
        var errData = {};
        try { errData = await res.json(); } catch (e) {}
        throw new Error(errData.description || errData.message || 'Errore ' + res.status);
      }
      closePopup();
      cartBtn.disabled = false;
      cartBtn.textContent = 'Aggiungi al carrello';

      var cartEl = document.querySelector('cart-drawer, mini-cart, ajax-cart');

      // Determina le sezioni da aggiornare (usa il metodo del tema se disponibile)
      var sectionIds = 'cart-drawer,cart-icon-bubble';
      if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
        sectionIds = cartEl.getSectionsToRender().map(function(s) { return s.id; }).join(',');
      }

      try {
        var sectRes = await fetch('/?sections=' + sectionIds);
        var sections = await sectRes.json();

        if (cartEl && typeof cartEl.renderContents === 'function') {
          // Metodo nativo del tema (Dawn e derivati)
          cartEl.renderContents({ sections: sections });
        } else {
          // Approccio universale: aggiorna elementi per ID
          var parser = new DOMParser();
          Object.values(sections).forEach(function(html) {
            if (!html) return;
            var doc = parser.parseFromString(html, 'text/html');
            doc.querySelectorAll('[id]:not([id^="shopify-section"])').forEach(function(fresh) {
              var live = document.getElementById(fresh.id);
              if (live && live !== fresh) live.innerHTML = fresh.innerHTML;
            });
          });
        }
      } catch (e) {}

      // Apri il carrello
      if (cartEl && typeof cartEl.open === 'function') {
        cartEl.open(document.querySelector('[aria-controls="CartDrawer"]'));
      } else {
        var cartToggle =
          document.querySelector('[aria-controls="CartDrawer"], [aria-controls="MiniCart"], [data-cart-toggle]') ||
          document.getElementById('cart-icon-bubble') ||
          document.querySelector('.cart-icon-bubble, .header__icon--cart');
        if (cartToggle) cartToggle.click();
        else window.location.href = '/cart';
      }
    } catch (err) {
      setError(err.message || "Errore nell'aggiunta al carrello. Riprova.");
      cartBtn.disabled = false;
      cartBtn.textContent = 'Aggiungi al carrello';
    }
  }

  /* ---- Init ---- */
  refreshSteppers();
  updateUI();

})();
